// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Log$SmartcutsMacros = require("./Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Logger$SmartcutsMacros = require("./Logger.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var JsExnUtils$SmartcutsMacros = require("../../bs-utils/src/JsExnUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");

function update_encode(encoder_state, encoder_sideEffect, v) {
  if (typeof v === "number") {
    return ["Ignore"];
  }
  switch (v.TAG | 0) {
    case /* Update */0 :
        return [
                "Update",
                Curry._1(encoder_state, v._0)
              ];
    case /* SideEffects */1 :
        return [
                "SideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
              ];
    case /* SerialSideEffects */2 :
        return [
                "SerialSideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
              ];
    case /* UpdateWithSideEffects */3 :
        return [
                "UpdateWithSideEffects",
                Curry._1(encoder_state, v._0),
                Decco.listToJson(encoder_sideEffect, v._1)
              ];
    case /* UpdateWithSerialSideEffects */4 :
        return [
                "UpdateWithSerialSideEffects",
                Curry._1(encoder_state, v._0),
                Decco.listToJson(encoder_sideEffect, v._1)
              ];
    
  }
}

function update_decode(decoder_state, decoder_sideEffect, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Ignore" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Ignore */0
                  };
          }
      case "SerialSideEffects" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SerialSideEffects */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SideEffects" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SideEffects */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Update" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Update */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "UpdateWithSerialSideEffects" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* UpdateWithSerialSideEffects */4,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$3 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "UpdateWithSideEffects" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* UpdateWithSideEffects */3,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$5 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyUpdate(stringifyState, stringifySideEffect, update) {
  if (typeof update === "number") {
    return "Ignore";
  }
  switch (update.TAG | 0) {
    case /* Update */0 :
        return "Update(" + (Curry._1(stringifyState, update._0) + ")");
    case /* SideEffects */1 :
        return "SideEffects([" + ($$String.concat(", ", List.map(stringifySideEffect, update._0)) + "])");
    case /* SerialSideEffects */2 :
        return "SerialSideEffects([" + ($$String.concat(", ", List.map(stringifySideEffect, update._0)) + "])");
    case /* UpdateWithSideEffects */3 :
        return "UpdateSideEffects(" + (Curry._1(stringifyState, update._0) + (", [" + ($$String.concat(", ", List.map(stringifySideEffect, update._1)) + "])")));
    case /* UpdateWithSerialSideEffects */4 :
        return "UpdateSerialSideEffects(" + (Curry._1(stringifyState, update._0) + (", [" + ($$String.concat(", ", List.map(stringifySideEffect, update._1)) + "])")));
    
  }
}

function eventSource_encode(encoder_listener, encoder_sideEffect, v) {
  if (typeof v === "number") {
    return ["ViaInitialize"];
  } else if (v.TAG === /* ViaListener */0) {
    return [
            "ViaListener",
            Curry._1(encoder_listener, v._0)
          ];
  } else {
    return [
            "ViaSideEffect",
            Curry._1(encoder_sideEffect, v._0),
            Decco.intToJson(v._1)
          ];
  }
}

function eventSource_decode(decoder_listener, decoder_sideEffect, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ViaInitialize" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaInitialize */0
                  };
          }
      case "ViaListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_listener, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ViaListener */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ViaSideEffect" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ViaSideEffect */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapEventSource(mapListener, mapSideEffect, eventSource) {
  if (typeof eventSource === "number") {
    return /* ViaInitialize */0;
  } else if (eventSource.TAG === /* ViaListener */0) {
    return {
            TAG: /* ViaListener */0,
            _0: Curry._1(mapListener, eventSource._0)
          };
  } else {
    return {
            TAG: /* ViaSideEffect */1,
            _0: Curry._1(mapSideEffect, eventSource._0),
            _1: eventSource._1
          };
  }
}

function stringifyEventSource(stringifyListener, stringifySideEffect, eventSource) {
  if (typeof eventSource === "number") {
    return "state machine initialization";
  } else if (eventSource.TAG === /* ViaListener */0) {
    return "listener = " + Curry._1(stringifyListener, eventSource._0);
  } else {
    return "side effect (id=" + (String(eventSource._1) + (") = " + Curry._1(stringifySideEffect, eventSource._0)));
  }
}

function transition_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, v) {
  return Js_dict.fromArray([
              [
                "eventId",
                Decco.intToJson(v.eventId)
              ],
              [
                "event",
                Curry._1(encoder_event, v.event)
              ],
              [
                "eventSource",
                eventSource_encode(encoder_listener, encoder_sideEffect, v.eventSource)
              ],
              [
                "update",
                update_encode(encoder_state, encoder_sideEffect, v.update)
              ],
              [
                "sideEffectIds",
                Decco.listToJson(Decco.intToJson, v.sideEffectIds)
              ]
            ]);
}

function transition_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var eventId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventId"), null));
  if (eventId.TAG === /* Ok */0) {
    var $$event = Curry._1(decoder_event, Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
    if ($$event.TAG === /* Ok */0) {
      var eventSource = eventSource_decode(decoder_listener, decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSource"), null));
      if (eventSource.TAG === /* Ok */0) {
        var update = update_decode(decoder_state, decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "update"), null));
        if (update.TAG === /* Ok */0) {
          var sideEffectIds = Decco.listFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sideEffectIds"), null));
          if (sideEffectIds.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      eventId: eventId._0,
                      event: $$event._0,
                      eventSource: eventSource._0,
                      update: update._0,
                      sideEffectIds: sideEffectIds._0
                    }
                  };
          }
          var e = sideEffectIds._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".sideEffectIds" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = update._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".update" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = eventSource._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".eventSource" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = $$event._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".event" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = eventId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".eventId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function t_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, v) {
  return Js_dict.fromArray([
              [
                "firstState",
                Curry._1(encoder_state, v.firstState)
              ],
              [
                "transitions",
                Decco.arrayToJson((function (param) {
                        return transition_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, param);
                      }), v.transitions)
              ],
              [
                "maxLength",
                Decco.optionToJson(Decco.intToJson, v.maxLength)
              ]
            ]);
}

function t_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var firstState = Curry._1(decoder_state, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstState"), null));
  if (firstState.TAG === /* Ok */0) {
    var transitions = Decco.arrayFromJson((function (param) {
            return transition_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "transitions"), null));
    if (transitions.TAG === /* Ok */0) {
      var maxLength = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maxLength"), null));
      if (maxLength.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  firstState: firstState._0,
                  transitions: transitions._0,
                  maxLength: maxLength._0
                }
              };
      }
      var e = maxLength._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maxLength" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = transitions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".transitions" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = firstState._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".firstState" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function make(maxLength, state, param) {
  return {
          firstState: state,
          transitions: [],
          maxLength: maxLength
        };
}

function recordTransition(eventId, $$event, eventSource, update, sideEffectIds, history) {
  var maxLength = history.maxLength;
  var transitions = history.transitions;
  if (maxLength === undefined) {
    return {
            firstState: history.firstState,
            transitions: $$Array.append(transitions, [{
                    eventId: eventId,
                    event: $$event,
                    eventSource: eventSource,
                    update: update,
                    sideEffectIds: sideEffectIds
                  }]),
            maxLength: history.maxLength
          };
  }
  if (maxLength === 0) {
    return history;
  }
  if (maxLength > transitions.length) {
    return {
            firstState: history.firstState,
            transitions: $$Array.append(transitions, [{
                    eventId: eventId,
                    event: $$event,
                    eventSource: eventSource,
                    update: update,
                    sideEffectIds: sideEffectIds
                  }]),
            maxLength: history.maxLength
          };
  }
  if (maxLength !== transitions.length) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: history length (" + (String(transitions.length) + (")is already greater than max length " + String(maxLength))));
  }
  var match = Caml_array.get(transitions, 0).update;
  var newFirstState;
  if (typeof match === "number") {
    newFirstState = history.firstState;
  } else {
    switch (match.TAG | 0) {
      case /* SideEffects */1 :
      case /* SerialSideEffects */2 :
          newFirstState = history.firstState;
          break;
      default:
        newFirstState = match._0;
    }
  }
  var transitionsExceptFirst = ArrayUtils$SmartcutsMacros.slice(1, transitions.length, transitions);
  return {
          firstState: newFirstState,
          transitions: $$Array.append(transitionsExceptFirst, [{
                  eventId: eventId,
                  event: $$event,
                  eventSource: eventSource,
                  update: update,
                  sideEffectIds: sideEffectIds
                }]),
          maxLength: history.maxLength
        };
}

function reset(history) {
  var maybeLastNewState = Util$SmartcutsMacros.shortcut((function (param) {
          var update = param.update;
          if (typeof update === "number") {
            return ;
          }
          switch (update.TAG | 0) {
            case /* SideEffects */1 :
            case /* SerialSideEffects */2 :
                return ;
            default:
              return Caml_option.some(update._0);
          }
        }), Belt_Array.reverse(history.transitions));
  return {
          firstState: maybeLastNewState !== undefined ? Caml_option.valFromOption(maybeLastNewState) : history.firstState,
          transitions: [],
          maxLength: history.maxLength
        };
}

function clearUpToAndIncludingEventId(history, eventId) {
  var transitions = history.transitions;
  var firstState = history.firstState;
  var maybeIndexOfMatchingTransition = Belt_Array.getIndexBy(transitions, (function (transition) {
          return transition.eventId === eventId;
        }));
  return Belt_Option.getWithDefault(Belt_Option.map(maybeIndexOfMatchingTransition, (function (i) {
                    return {
                            firstState: Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Array.getBy(Belt_Array.reverse(Belt_Array.slice(transitions, 0, i)), (function (param) {
                                            var tmp = param.update;
                                            if (typeof tmp === "number") {
                                              return false;
                                            }
                                            switch (tmp.TAG | 0) {
                                              case /* SideEffects */1 :
                                              case /* SerialSideEffects */2 :
                                                  return false;
                                              default:
                                                return true;
                                            }
                                          })), (function (param) {
                                        var update = param.update;
                                        if (typeof update === "number") {
                                          return ;
                                        }
                                        switch (update.TAG | 0) {
                                          case /* Update */0 :
                                          case /* UpdateWithSideEffects */3 :
                                          case /* UpdateWithSerialSideEffects */4 :
                                              return Caml_option.some(update._0);
                                          default:
                                            return ;
                                        }
                                      })), firstState),
                            transitions: Belt_Array.sliceToEnd(transitions, i + 1 | 0),
                            maxLength: history.maxLength
                          };
                  })), history);
}

function map(mapState, mapEvent, mapSideEffect, mapListener, param) {
  return {
          firstState: Curry._1(mapState, param.firstState),
          transitions: $$Array.map((function (param) {
                  var update = param.update;
                  var tmp;
                  if (typeof update === "number") {
                    tmp = /* Ignore */0;
                  } else {
                    switch (update.TAG | 0) {
                      case /* Update */0 :
                          tmp = {
                            TAG: /* Update */0,
                            _0: Curry._1(mapState, update._0)
                          };
                          break;
                      case /* SideEffects */1 :
                          tmp = {
                            TAG: /* SideEffects */1,
                            _0: List.map(mapSideEffect, update._0)
                          };
                          break;
                      case /* SerialSideEffects */2 :
                          tmp = {
                            TAG: /* SerialSideEffects */2,
                            _0: List.map(mapSideEffect, update._0)
                          };
                          break;
                      case /* UpdateWithSideEffects */3 :
                          tmp = {
                            TAG: /* UpdateWithSideEffects */3,
                            _0: Curry._1(mapState, update._0),
                            _1: List.map(mapSideEffect, update._1)
                          };
                          break;
                      case /* UpdateWithSerialSideEffects */4 :
                          tmp = {
                            TAG: /* UpdateWithSerialSideEffects */4,
                            _0: Curry._1(mapState, update._0),
                            _1: List.map(mapSideEffect, update._1)
                          };
                          break;
                      
                    }
                  }
                  return {
                          eventId: param.eventId,
                          event: Curry._1(mapEvent, param.event),
                          eventSource: mapEventSource(mapListener, mapSideEffect, param.eventSource),
                          update: tmp,
                          sideEffectIds: param.sideEffectIds
                        };
                }), param.transitions),
          maxLength: param.maxLength
        };
}

function toTransitionsWithPriorStates(param) {
  return $$Array.fold_left((function (param, param$1) {
                  var update = param$1.update;
                  var priorState = param[0];
                  var nextState;
                  if (typeof update === "number") {
                    nextState = priorState;
                  } else {
                    switch (update.TAG | 0) {
                      case /* SideEffects */1 :
                      case /* SerialSideEffects */2 :
                          nextState = priorState;
                          break;
                      default:
                        nextState = update._0;
                    }
                  }
                  return [
                          nextState,
                          $$Array.append(param[1], [{
                                  priorState: priorState,
                                  nextState: nextState,
                                  eventId: param$1.eventId,
                                  event: param$1.event,
                                  eventSource: param$1.eventSource,
                                  update: update,
                                  sideEffectIds: param$1.sideEffectIds
                                }])
                        ];
                }), [
                param.firstState,
                []
              ], param.transitions)[1];
}

function containsEventId(eventId, param) {
  return $$Array.exists((function (transition) {
                return transition.eventId === eventId;
              }), param.transitions);
}

function containsSideEffectId(sideEffectId, param) {
  return $$Array.exists((function (param) {
                return List.mem(sideEffectId, param.sideEffectIds);
              }), param.transitions);
}

function truncateToLastExitFailure(stringifyEvent, buffer, history) {
  var transitions = history.transitions;
  var match = Belt_Array.reduceWithIndex(Belt_Array.reverse(transitions), [
        undefined,
        false,
        undefined,
        buffer
      ], (function (triplet, param, i) {
          var update = param.update;
          var $$event = param.event;
          var buffer = triplet[3];
          var maybeFirstNonFailIndexWithState = triplet[2];
          var hasSeenFail = triplet[1];
          var maybeLastFailIndex = triplet[0];
          if (maybeLastFailIndex !== undefined) {
            if (maybeFirstNonFailIndexWithState !== undefined) {
              return triplet;
            }
            var stringifiedEvent = Curry._1(stringifyEvent, $$event);
            if (stringifiedEvent.includes("Fail(")) {
              return [
                      maybeLastFailIndex,
                      true,
                      maybeFirstNonFailIndexWithState,
                      buffer
                    ];
            }
            if (!hasSeenFail) {
              return triplet;
            }
            var exit = 0;
            if (typeof update === "number") {
              exit = 2;
            } else {
              switch (update.TAG | 0) {
                case /* Update */0 :
                case /* UpdateWithSideEffects */3 :
                case /* UpdateWithSerialSideEffects */4 :
                    exit = 1;
                    break;
                default:
                  exit = 2;
              }
            }
            switch (exit) {
              case 1 :
                  if (buffer === 0) {
                    return [
                            maybeLastFailIndex,
                            hasSeenFail,
                            [
                              i,
                              update._0
                            ],
                            0
                          ];
                  } else {
                    return [
                            maybeLastFailIndex,
                            hasSeenFail,
                            undefined,
                            buffer - 1 | 0
                          ];
                  }
              case 2 :
                  return [
                          maybeLastFailIndex,
                          hasSeenFail,
                          undefined,
                          buffer - 1 | 0
                        ];
              
            }
          } else {
            if (maybeFirstNonFailIndexWithState !== undefined) {
              return triplet;
            }
            var stringifiedEvent$1 = Curry._1(stringifyEvent, $$event);
            if (stringifiedEvent$1.includes("ExitFailure(")) {
              return [
                      i,
                      hasSeenFail,
                      undefined,
                      buffer
                    ];
            } else {
              return triplet;
            }
          }
        }));
  var maybeFirstNonFailIndexWithState = match[2];
  var match$1 = maybeFirstNonFailIndexWithState !== undefined ? [
      Belt_Array.sliceToEnd(transitions, (transitions.length - maybeFirstNonFailIndexWithState[0] | 0) - 1 | 0),
      maybeFirstNonFailIndexWithState[1]
    ] : [
      transitions,
      history.firstState
    ];
  return {
          firstState: match$1[1],
          transitions: match$1[0],
          maxLength: history.maxLength
        };
}

function lastNTransistions(param, n) {
  var transitions = param.transitions;
  var to_ = transitions.length;
  var from = Math.max(0, to_ - n | 0);
  return ArrayUtils$SmartcutsMacros.slice(from, to_, transitions);
}

var $$History = {
  transition_encode: transition_encode,
  transition_decode: transition_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  make: make,
  recordTransition: recordTransition,
  reset: reset,
  clearUpToAndIncludingEventId: clearUpToAndIncludingEventId,
  map: map,
  toTransitionsWithPriorStates: toTransitionsWithPriorStates,
  containsEventId: containsEventId,
  containsSideEffectId: containsSideEffectId,
  truncateToLastExitFailure: truncateToLastExitFailure,
  lastNTransistions: lastNTransistions
};

function sideEffectErrorContext_encode(encoder_sideEffect, encoder_state, v) {
  return Js_dict.fromArray([
              [
                "sideEffectId",
                Decco.intToJson(v.sideEffectId)
              ],
              [
                "sideEffect",
                Curry._1(encoder_sideEffect, v.sideEffect)
              ],
              [
                "maybeState",
                Decco.optionToJson(encoder_state, v.maybeState)
              ],
              [
                "extraMessage",
                Decco.stringToJson(v.extraMessage)
              ]
            ]);
}

function sideEffectErrorContext_decode(decoder_sideEffect, decoder_state, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sideEffectId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sideEffectId"), null));
  if (sideEffectId.TAG === /* Ok */0) {
    var sideEffect = Curry._1(decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sideEffect"), null));
    if (sideEffect.TAG === /* Ok */0) {
      var maybeState = Decco.optionFromJson(decoder_state, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeState"), null));
      if (maybeState.TAG === /* Ok */0) {
        var extraMessage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "extraMessage"), null));
        if (extraMessage.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    sideEffectId: sideEffectId._0,
                    sideEffect: sideEffect._0,
                    maybeState: maybeState._0,
                    extraMessage: extraMessage._0
                  }
                };
        }
        var e = extraMessage._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".extraMessage" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = maybeState._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maybeState" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sideEffect._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sideEffect" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = sideEffectId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sideEffectId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function mapSideEffectErrorContext(mapSideEffect, mapState, param) {
  return {
          sideEffectId: param.sideEffectId,
          sideEffect: Curry._1(mapSideEffect, param.sideEffect),
          maybeState: Belt_Option.map(param.maybeState, mapState),
          extraMessage: param.extraMessage
        };
}

function stringifySideEffectErrorContext(stringifySideEffect, stringifyState, param) {
  return "{sideEffect=" + (Curry._1(stringifySideEffect, param.sideEffect) + (", maybeState=" + (OptionUtils$SmartcutsMacros.stringify(stringifyState, param.maybeState) + (", extraMessage" + (param.extraMessage + "}")))));
}

function transitionErrorContext_encode(encoder_state, encoder_event, v) {
  return Js_dict.fromArray([
              [
                "state",
                Curry._1(encoder_state, v.state)
              ],
              [
                "event",
                Curry._1(encoder_event, v.event)
              ],
              [
                "eventId",
                Decco.intToJson(v.eventId)
              ],
              [
                "extraMessage",
                Decco.stringToJson(v.extraMessage)
              ]
            ]);
}

function transitionErrorContext_decode(decoder_state, decoder_event, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var state = Curry._1(decoder_state, Belt_Option.getWithDefault(Js_dict.get(dict$1, "state"), null));
  if (state.TAG === /* Ok */0) {
    var $$event = Curry._1(decoder_event, Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
    if ($$event.TAG === /* Ok */0) {
      var eventId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventId"), null));
      if (eventId.TAG === /* Ok */0) {
        var extraMessage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "extraMessage"), null));
        if (extraMessage.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    state: state._0,
                    event: $$event._0,
                    eventId: eventId._0,
                    extraMessage: extraMessage._0
                  }
                };
        }
        var e = extraMessage._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".extraMessage" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = eventId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".eventId" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = $$event._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".event" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = state._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".state" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function mapTransitionErrorContext(mapState, mapEvent, param) {
  return {
          state: Curry._1(mapState, param.state),
          event: Curry._1(mapEvent, param.event),
          eventId: param.eventId,
          extraMessage: param.extraMessage
        };
}

function stringifyTransitionErrorContext(stringifyState, stringifyEvent, param) {
  return "{state=" + (Curry._1(stringifyState, param.state) + (", event=" + (Curry._1(stringifyEvent, param.event) + (", extraMessage=" + (param.extraMessage + "}")))));
}

function listenerErrorContext_encode(encoder_listener, v) {
  return Js_dict.fromArray([
              [
                "listener",
                Curry._1(encoder_listener, v.listener)
              ],
              [
                "extraMessage",
                Decco.stringToJson(v.extraMessage)
              ]
            ]);
}

function listenerErrorContext_decode(decoder_listener, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var listener = Curry._1(decoder_listener, Belt_Option.getWithDefault(Js_dict.get(dict$1, "listener"), null));
  if (listener.TAG === /* Ok */0) {
    var extraMessage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "extraMessage"), null));
    if (extraMessage.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                listener: listener._0,
                extraMessage: extraMessage._0
              }
            };
    }
    var e = extraMessage._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".extraMessage" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = listener._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".listener" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function mapListenerErrorContext(mapListener, param) {
  return {
          listener: Curry._1(mapListener, param.listener),
          extraMessage: param.extraMessage
        };
}

function t_encode$1(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, v) {
  switch (v.TAG | 0) {
    case /* DidErrDuringTransition */0 :
        return [
                "DidErrDuringTransition",
                transitionErrorContext_encode(encoder_state, encoder_event, v._0)
              ];
    case /* DidErrDuringSideEffect */1 :
        return [
                "DidErrDuringSideEffect",
                sideEffectErrorContext_encode(encoder_sideEffect, encoder_state, v._0)
              ];
    case /* DidErrDuringListener */2 :
        return [
                "DidErrDuringListener",
                listenerErrorContext_encode(encoder_listener, v._0)
              ];
    
  }
}

function t_decode$1(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidErrDuringListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = listenerErrorContext_decode(decoder_listener, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidErrDuringListener */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidErrDuringSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = sideEffectErrorContext_decode(decoder_sideEffect, decoder_state, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidErrDuringSideEffect */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DidErrDuringTransition" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = transitionErrorContext_decode(decoder_state, decoder_event, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidErrDuringTransition */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map$1(mapState, mapEvent, mapSideEffect, mapListener, errorContext) {
  switch (errorContext.TAG | 0) {
    case /* DidErrDuringTransition */0 :
        return {
                TAG: /* DidErrDuringTransition */0,
                _0: mapTransitionErrorContext(mapState, mapEvent, errorContext._0)
              };
    case /* DidErrDuringSideEffect */1 :
        return {
                TAG: /* DidErrDuringSideEffect */1,
                _0: mapSideEffectErrorContext(mapSideEffect, mapState, errorContext._0)
              };
    case /* DidErrDuringListener */2 :
        return {
                TAG: /* DidErrDuringListener */2,
                _0: mapListenerErrorContext(mapListener, errorContext._0)
              };
    
  }
}

var hoist = map$1;

function stringify(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, errorContext) {
  switch (errorContext.TAG | 0) {
    case /* DidErrDuringTransition */0 :
        return "DidErrDuringTransition(state=" + (stringifyTransitionErrorContext(stringifyState, stringifyEvent, errorContext._0) + ")");
    case /* DidErrDuringSideEffect */1 :
        return "DidErrDuringSideEffect(" + (stringifySideEffectErrorContext(stringifySideEffect, stringifyState, errorContext._0) + ")");
    case /* DidErrDuringListener */2 :
        var match = errorContext._0;
        return "DidErrDuringListener(listener=" + (Curry._1(stringifyListener, match.listener) + (", extraMessage=" + (match.extraMessage + ")")));
    
  }
}

var WithListener = {
  listenerErrorContext_encode: listenerErrorContext_encode,
  listenerErrorContext_decode: listenerErrorContext_decode,
  mapListenerErrorContext: mapListenerErrorContext,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  map: map$1,
  hoist: hoist,
  stringify: stringify
};

function t_encode$2(encoder_state, encoder_event, encoder_sideEffect, v) {
  if (v.TAG === /* DidErrDuringTransition */0) {
    return [
            "DidErrDuringTransition",
            transitionErrorContext_encode(encoder_state, encoder_event, v._0)
          ];
  } else {
    return [
            "DidErrDuringSideEffect",
            sideEffectErrorContext_encode(encoder_sideEffect, encoder_state, v._0)
          ];
  }
}

function t_decode$2(decoder_state, decoder_event, decoder_sideEffect, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidErrDuringSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = sideEffectErrorContext_decode(decoder_sideEffect, decoder_state, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidErrDuringSideEffect */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidErrDuringTransition" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = transitionErrorContext_decode(decoder_state, decoder_event, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidErrDuringTransition */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function hoistToErrorContextWithoutListener(hoistState, hoistEvent, hoistSideEffect, errorContext) {
  if (errorContext.TAG === /* DidErrDuringTransition */0) {
    var match = errorContext._0;
    return {
            TAG: /* DidErrDuringTransition */0,
            _0: {
              state: Curry._1(hoistState, match.state),
              event: Curry._1(hoistEvent, match.event),
              eventId: match.eventId,
              extraMessage: match.extraMessage
            }
          };
  }
  var match$1 = errorContext._0;
  return {
          TAG: /* DidErrDuringSideEffect */1,
          _0: {
            sideEffectId: match$1.sideEffectId,
            sideEffect: Curry._1(hoistSideEffect, match$1.sideEffect),
            maybeState: Belt_Option.map(match$1.maybeState, hoistState),
            extraMessage: match$1.extraMessage
          }
        };
}

function hoistToErrorContextWithListener(hoistState, hoistEvent, hoistSideEffect, errorContext) {
  if (errorContext.TAG === /* DidErrDuringTransition */0) {
    var match = errorContext._0;
    return {
            TAG: /* DidErrDuringTransition */0,
            _0: {
              state: Curry._1(hoistState, match.state),
              event: Curry._1(hoistEvent, match.event),
              eventId: match.eventId,
              extraMessage: match.extraMessage
            }
          };
  }
  var match$1 = errorContext._0;
  return {
          TAG: /* DidErrDuringSideEffect */1,
          _0: {
            sideEffectId: match$1.sideEffectId,
            sideEffect: Curry._1(hoistSideEffect, match$1.sideEffect),
            maybeState: Belt_Option.map(match$1.maybeState, hoistState),
            extraMessage: match$1.extraMessage
          }
        };
}

function map$2(mapState, mapEvent, mapSideEffect, errorContext) {
  if (errorContext.TAG === /* DidErrDuringTransition */0) {
    return {
            TAG: /* DidErrDuringTransition */0,
            _0: mapTransitionErrorContext(mapState, mapEvent, errorContext._0)
          };
  } else {
    return {
            TAG: /* DidErrDuringSideEffect */1,
            _0: mapSideEffectErrorContext(mapSideEffect, mapState, errorContext._0)
          };
  }
}

function stringify$1(stringifyState, stringifyEvent, stringifySideEffect, errorContext) {
  if (errorContext.TAG === /* DidErrDuringTransition */0) {
    return "DidErrDuringTransition(state=" + (stringifyTransitionErrorContext(stringifyState, stringifyEvent, errorContext._0) + ")");
  } else {
    return "DidErrDuringSideEffect(" + (stringifySideEffectErrorContext(stringifySideEffect, stringifyState, errorContext._0) + ")");
  }
}

var WithoutListener = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  hoistToErrorContextWithoutListener: hoistToErrorContextWithoutListener,
  hoistToErrorContextWithListener: hoistToErrorContextWithListener,
  map: map$2,
  stringify: stringify$1
};

var ErrorContext = {
  sideEffectErrorContext_encode: sideEffectErrorContext_encode,
  sideEffectErrorContext_decode: sideEffectErrorContext_decode,
  mapSideEffectErrorContext: mapSideEffectErrorContext,
  stringifySideEffectErrorContext: stringifySideEffectErrorContext,
  transitionErrorContext_encode: transitionErrorContext_encode,
  transitionErrorContext_decode: transitionErrorContext_decode,
  mapTransitionErrorContext: mapTransitionErrorContext,
  stringifyTransitionErrorContext: stringifyTransitionErrorContext,
  WithListener: WithListener,
  WithoutListener: WithoutListener
};

function t_encode$3(encoder_otherFailureReason, v) {
  if (typeof v === "number") {
    return ["FailWithTimeout"];
  }
  switch (v.TAG | 0) {
    case /* FailWithOtherReason */0 :
        return [
                "FailWithOtherReason",
                Curry._1(encoder_otherFailureReason, v._0)
              ];
    case /* FailWithJsExn */1 :
        return [
                "FailWithJsExn",
                JsExnUtils$SmartcutsMacros.t_encode(v._0)
              ];
    case /* FailWithJsPromiseError */2 :
        return [
                "FailWithJsPromiseError",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
              ];
    
  }
}

function t_decode$3(decoder_otherFailureReason, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FailWithJsExn" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithJsExn */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FailWithJsPromiseError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithJsPromiseError */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "FailWithOtherReason" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(decoder_otherFailureReason, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithOtherReason */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "FailWithTimeout" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithTimeout */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$2(stringifyOtherFailureReason, exitFailure) {
  if (typeof exitFailure === "number") {
    return "FailWithTimeout";
  }
  switch (exitFailure.TAG | 0) {
    case /* FailWithOtherReason */0 :
        return "FailWithOtherReason(" + (Curry._1(stringifyOtherFailureReason, exitFailure._0) + ")");
    case /* FailWithJsExn */1 :
        return "FailWithJsExn(exn=" + (OptionUtils$SmartcutsMacros.withDefault("", exitFailure._0.message) + ")");
    case /* FailWithJsPromiseError */2 :
        return "FailWithJsPromiseError(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, exitFailure._0) + ")");
    
  }
}

function stringifyWithoutDetails(stringifyOtherFailureReason, exitFailure) {
  if (typeof exitFailure === "number") {
    return "FailWithTimeout";
  }
  switch (exitFailure.TAG | 0) {
    case /* FailWithOtherReason */0 :
        return Curry._1(stringifyOtherFailureReason, exitFailure._0);
    case /* FailWithJsExn */1 :
        return JsExnUtils$SmartcutsMacros.stringify(exitFailure._0);
    case /* FailWithJsPromiseError */2 :
        return Curry._1(JsPromiseErrorUtils$SmartcutsMacros.ErrorType.stringifyWithoutDetails, Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, exitFailure._0));
    
  }
}

function minify(minifyOtherFailureReason, v) {
  if (typeof v === "number" || v.TAG !== /* FailWithOtherReason */0) {
    return v;
  } else {
    return {
            TAG: /* FailWithOtherReason */0,
            _0: Curry._1(minifyOtherFailureReason, v._0)
          };
  }
}

var FailWith = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$2,
  stringifyWithoutDetails: stringifyWithoutDetails,
  minify: minify
};

function t_encode$4(encoder_otherFailureReason, encoder_context, v) {
  return Js_dict.fromArray([
              [
                "failWith",
                t_encode$3(encoder_otherFailureReason, v.failWith)
              ],
              [
                "context",
                Curry._1(encoder_context, v.context)
              ]
            ]);
}

function t_decode$4(decoder_otherFailureReason, decoder_context, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var failWith = t_decode$3(decoder_otherFailureReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failWith"), null));
  if (failWith.TAG === /* Ok */0) {
    var context = Curry._1(decoder_context, Belt_Option.getWithDefault(Js_dict.get(dict$1, "context"), null));
    if (context.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                failWith: failWith._0,
                context: context._0
              }
            };
    }
    var e = context._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".context" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = failWith._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".failWith" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var Generic = {
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

function t_encode$5(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v) {
  return t_encode$4(encoder_otherFailureReason, (function (param) {
                return t_encode$1(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, param);
              }), v);
}

function t_decode$5(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, v) {
  return t_decode$4(decoder_otherFailureReason, (function (param) {
                return t_decode$1(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, param);
              }), v);
}

function map$3(mapState, mapEvent, mapSideEffect, mapListener, param) {
  return {
          failWith: param.failWith,
          context: map$1(mapState, mapEvent, mapSideEffect, mapListener, param.context)
        };
}

function stringify$3(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, param) {
  return "{failWith: " + (stringify$2(stringifyOtherFailureReason, param.failWith) + (", context: " + (stringify(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, param.context) + "}")));
}

var WithListener$1 = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  map: map$3,
  stringify: stringify$3
};

function t_encode$6(encoder_state, encoder_event, encoder_sideEffect, encoder_otherFailureReason, v) {
  return t_encode$4(encoder_otherFailureReason, (function (param) {
                return t_encode$2(encoder_state, encoder_event, encoder_sideEffect, param);
              }), v);
}

function t_decode$6(decoder_state, decoder_event, decoder_sideEffect, decoder_otherFailureReason, v) {
  return t_decode$4(decoder_otherFailureReason, (function (param) {
                return t_decode$2(decoder_state, decoder_event, decoder_sideEffect, param);
              }), v);
}

function map$4(mapState, mapEvent, mapSideEffect, param) {
  return {
          failWith: param.failWith,
          context: map$2(mapState, mapEvent, mapSideEffect, param.context)
        };
}

function hoistToFailureWithListener(hoistState, hoistEvent, hoistSideEffect, param) {
  return {
          failWith: param.failWith,
          context: hoistToErrorContextWithListener(hoistState, hoistEvent, hoistSideEffect, param.context)
        };
}

function stringify$4(stringifyState, stringifyEvent, stringifySideEffect, stringifyOtherFailureReason, param) {
  return "{failWith: " + (stringify$2(stringifyOtherFailureReason, param.failWith) + (", context: " + (stringify$1(stringifyState, stringifyEvent, stringifySideEffect, param.context) + "}")));
}

var WithoutListener$1 = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  map: map$4,
  hoistToFailureWithListener: hoistToFailureWithListener,
  stringify: stringify$4
};

function t_encode$7(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v) {
  return Js_dict.fromArray([
              [
                "failure",
                t_encode$3(encoder_otherFailureReason, v.failure)
              ],
              [
                "errorContext",
                t_encode$1(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, v.errorContext)
              ],
              [
                "history",
                t_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, v.history)
              ]
            ]);
}

function t_decode$7(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var failure = t_decode$3(decoder_otherFailureReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failure"), null));
  if (failure.TAG === /* Ok */0) {
    var errorContext = t_decode$1(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, Belt_Option.getWithDefault(Js_dict.get(dict$1, "errorContext"), null));
    if (errorContext.TAG === /* Ok */0) {
      var history = t_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "history"), null));
      if (history.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  failure: failure._0,
                  errorContext: errorContext._0,
                  history: history._0
                }
              };
      }
      var e = history._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".history" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = errorContext._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".errorContext" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = failure._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".failure" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$5(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, param) {
  return "{failure=" + (stringify$2(stringifyOtherFailureReason, param.failure) + (", errorContext=" + (stringify(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, param.errorContext) + (", history({len: " + (String(param.history.transitions.length) + "})}")))));
}

var FailureInfo = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringify: stringify$5
};

var Root = {
  FailureInfo: FailureInfo
};

var Failure = {
  ErrorContext: ErrorContext,
  FailWith: FailWith,
  Generic: Generic,
  WithListener: WithListener$1,
  WithoutListener: WithoutListener$1,
  Root: Root
};

function t_encode$8(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v) {
  if (typeof v === "number") {
    if (v === /* ExitSuccess */0) {
      return ["ExitSuccess"];
    } else {
      return ["ExitFromPossibleInfiniteFailureLoop"];
    }
  } else if (v.TAG === /* ExitFailure */0) {
    return [
            "ExitFailure",
            t_encode$5(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v._0)
          ];
  } else {
    return [
            "ExitFromPossibleStaleState",
            Curry._1(encoder_state, v._0)
          ];
  }
}

function t_decode$8(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ExitFailure" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$5(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExitFailure */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ExitFromPossibleInfiniteFailureLoop" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitFromPossibleInfiniteFailureLoop */1
                  };
          }
      case "ExitFromPossibleStaleState" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExitFromPossibleStaleState */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ExitSuccess" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitSuccess */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map$5(mapState, mapEvent, mapSideEffect, mapListener, exitReason) {
  if (typeof exitReason === "number") {
    if (exitReason === /* ExitSuccess */0) {
      return /* ExitSuccess */0;
    } else {
      return /* ExitFromPossibleInfiniteFailureLoop */1;
    }
  } else if (exitReason.TAG === /* ExitFailure */0) {
    return {
            TAG: /* ExitFailure */0,
            _0: map$3(mapState, mapEvent, mapSideEffect, mapListener, exitReason._0)
          };
  } else {
    return {
            TAG: /* ExitFromPossibleStaleState */1,
            _0: Curry._1(mapState, exitReason._0)
          };
  }
}

function stringify$6(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, exitReason) {
  if (typeof exitReason === "number") {
    if (exitReason === /* ExitSuccess */0) {
      return "ExitSuccess";
    } else {
      return "ExitFromPossibleInfiniteFailureLoop";
    }
  } else if (exitReason.TAG === /* ExitFailure */0) {
    return "ExitFailure(" + (stringify$3(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, exitReason._0) + ")");
  } else {
    return "ExitFromPossibleStaleState(" + (Curry._1(stringifyState, exitReason._0) + ")");
  }
}

var WithListener$2 = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  map: map$5,
  stringify: stringify$6
};

function t_encode$9(encoder_state, encoder_event, encoder_sideEffect, encoder_otherFailureReason, v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["ExitFromPossibleInfiniteFailureLoop"];
    } else {
      return ["ExitSuccess"];
    }
  } else {
    return [
            "ExitFailure",
            t_encode$6(encoder_state, encoder_event, encoder_sideEffect, encoder_otherFailureReason, v._0)
          ];
  }
}

function t_decode$9(decoder_state, decoder_event, decoder_sideEffect, decoder_otherFailureReason, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ExitFailure" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$6(decoder_state, decoder_event, decoder_sideEffect, decoder_otherFailureReason, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitFailure */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ExitFromPossibleInfiniteFailureLoop" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitFromPossibleInfiniteFailureLoop */1
                  };
          }
      case "ExitSuccess" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitSuccess */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map$6(mapState, mapEvent, mapSideEffect, exitReason) {
  if (typeof exitReason === "number") {
    if (exitReason !== 0) {
      return /* ExitFromPossibleInfiniteFailureLoop */1;
    } else {
      return /* ExitSuccess */0;
    }
  } else {
    return /* ExitFailure */{
            _0: map$4(mapState, mapEvent, mapSideEffect, exitReason._0)
          };
  }
}

function stringify$7(stringifyState, stringifyEvent, stringifySideEffect, stringifyOtherFailureReason, exitReason) {
  if (typeof exitReason === "number") {
    if (exitReason !== 0) {
      return "ExitFromPossibleInfiniteFailureLoop";
    } else {
      return "ExitSuccess";
    }
  } else {
    return "ExitFailure(" + (stringify$4(stringifyState, stringifyEvent, stringifySideEffect, stringifyOtherFailureReason, exitReason._0) + ")");
  }
}

function hoistToExitReasonWithoutListener(hoistState, hoistEvent, hoistSideEffect, exitReason) {
  if (typeof exitReason === "number") {
    if (exitReason !== 0) {
      return /* ExitFromPossibleInfiniteFailureLoop */1;
    } else {
      return /* ExitSuccess */0;
    }
  } else {
    return /* ExitFailure */{
            _0: map$4(hoistState, hoistEvent, hoistSideEffect, exitReason._0)
          };
  }
}

function hoistToExitReasonWithListener(hoistState, hoistEvent, hoistSideEffect, exitReason) {
  if (typeof exitReason === "number") {
    if (exitReason !== 0) {
      return /* ExitFromPossibleInfiniteFailureLoop */1;
    } else {
      return /* ExitSuccess */0;
    }
  } else {
    return {
            TAG: /* ExitFailure */0,
            _0: hoistToFailureWithListener(hoistState, hoistEvent, hoistSideEffect, exitReason._0)
          };
  }
}

var WithoutListener$2 = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  map: map$6,
  stringify: stringify$7,
  hoistToExitReasonWithoutListener: hoistToExitReasonWithoutListener,
  hoistToExitReasonWithListener: hoistToExitReasonWithListener
};

var ExitReason = {
  WithListener: WithListener$2,
  WithoutListener: WithoutListener$2
};

function t_encode$10(encoder_exitReason, v) {
  return Js_dict.fromArray([
              [
                "mainExitReason",
                Curry._1(encoder_exitReason, v.mainExitReason)
              ],
              [
                "otherExitReasons",
                Decco.listToJson(encoder_exitReason, v.otherExitReasons)
              ]
            ]);
}

function t_decode$10(decoder_exitReason, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var mainExitReason = Curry._1(decoder_exitReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainExitReason"), null));
  if (mainExitReason.TAG === /* Ok */0) {
    var otherExitReasons = Decco.listFromJson(decoder_exitReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "otherExitReasons"), null));
    if (otherExitReasons.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                mainExitReason: mainExitReason._0,
                otherExitReasons: otherExitReasons._0
              }
            };
    }
    var e = otherExitReasons._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".otherExitReasons" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = mainExitReason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".mainExitReason" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function initWithMainReason(mainExitReason) {
  return {
          mainExitReason: mainExitReason,
          otherExitReasons: /* [] */0
        };
}

function addExitReason(exitReason, allExitReasons) {
  return {
          mainExitReason: allExitReasons.mainExitReason,
          otherExitReasons: {
            hd: exitReason,
            tl: allExitReasons.otherExitReasons
          }
        };
}

function stringify$8(stringifyExitReason, param) {
  return "{mainExitReason: " + (Curry._1(stringifyExitReason, param.mainExitReason) + (", otherExitReasons: " + (StringUtils$SmartcutsMacros.join(", ", List.map(stringifyExitReason, param.otherExitReasons)) + "}")));
}

function map$7(mapExitReason, param) {
  return {
          mainExitReason: Curry._1(mapExitReason, param.mainExitReason),
          otherExitReasons: List.map(mapExitReason, param.otherExitReasons)
        };
}

var AllExitReasons = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  initWithMainReason: initWithMainReason,
  addExitReason: addExitReason,
  stringify: stringify$8,
  map: map$7
};

var Exit = {
  ExitReason: ExitReason,
  AllExitReasons: AllExitReasons
};

var logYellow = Logger$SmartcutsMacros.createYellowLogger(Log$SmartcutsMacros.stateMachineCore);

function logSideEffects(indentOpt, prefix, stringifySideEffect, sideEffects) {
  var indent = indentOpt !== undefined ? indentOpt : 2;
  if (sideEffects) {
    if (sideEffects.tl) {
      logYellow(String(List.length(sideEffects)) + (" " + (prefix + " side effects")));
      Belt_List.forEachWithIndex(sideEffects, (function (i, sideEffect) {
              return logYellow(StringUtils$SmartcutsMacros.indent(undefined, indent) + (String(i) + (") " + Curry._1(stringifySideEffect, sideEffect))));
            }));
      return ;
    } else {
      return logYellow("Side effect = " + Curry._1(stringifySideEffect, sideEffects.hd));
    }
  } else {
    return logYellow("No side effects");
  }
}

function logSideEffectsWithIds(indentOpt, prefix, stringifySideEffect, sideEffectsWithIds) {
  var indent = indentOpt !== undefined ? indentOpt : 2;
  if (!sideEffectsWithIds) {
    return logYellow("No side effects");
  }
  if (sideEffectsWithIds.tl) {
    logYellow(String(List.length(sideEffectsWithIds)) + (" " + (prefix + " side effects")));
    return Belt_List.forEachWithIndex(sideEffectsWithIds, (function (i, param) {
                  return logYellow(StringUtils$SmartcutsMacros.indent(undefined, indent) + (String(i) + (") (id=" + (String(param[1]) + (")" + Curry._1(stringifySideEffect, param[0]))))));
                }));
  }
  var match = sideEffectsWithIds.hd;
  return logYellow("Side effect (id=" + (String(match[1]) + (") = " + Curry._1(stringifySideEffect, match[0]))));
}

function maybeLogTransition($$event, eventSource, stateMachine) {
  var match = stateMachine.options.logTransitions;
  if (typeof match === "number" || !(match.TAG === /* DoLogTransitions */0 && !Curry._2(match._4, stateMachine.state.contents, $$event))) {
    return ;
  } else {
    logYellow("\n\n========== NEW TRANSITION ==========");
    logYellow("Caused by " + stringifyEventSource(match._3, match._2, eventSource));
    logYellow("\n");
    logYellow("(prior state, event) =");
    logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + Curry._1(match._0, stateMachine.state.contents));
    logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + Curry._1(match._1, $$event));
    return logYellow("\n");
  }
}

function maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, sideEffectIds) {
  var match = stateMachine.options.logTransitions;
  if (typeof match === "number") {
    return ;
  }
  if (Curry._2(match._4, stateMachine.state.contents, $$event)) {
    return ;
  }
  if (typeof match !== "number") {
    if (match.TAG === /* DoLogTransitions */0) {
      var stringifySideEffect = match._2;
      var stringifyState = match._0;
      if (typeof update !== "number") {
        switch (update.TAG | 0) {
          case /* Update */0 :
              var nextState = update._0;
              logYellow("Next state =");
              var tmp;
              try {
                tmp = Caml_obj.caml_equal(nextState, stateMachine.state.contents) ? " (same state)" : "";
              }
              catch (raw_msg){
                var msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
                if (msg.RE_EXN_ID === "Invalid_argument") {
                  if (msg._1 === "equal: functional value") {
                    tmp = "(unknown state equality)";
                  } else {
                    throw msg;
                  }
                } else {
                  throw msg;
                }
              }
              logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, nextState) + tmp));
              logYellow("No side effects");
              break;
          case /* SideEffects */1 :
              logYellow("Next state =");
              logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, stateMachine.state.contents) + " (same state)"));
              var sideEffectsWithIds = List.mapi((function (i, sideEffect) {
                      return [
                              sideEffect,
                              stateMachine.nextSideEffectId.contents + i | 0
                            ];
                    }), update._0);
              logSideEffectsWithIds(undefined, "Parallel", stringifySideEffect, sideEffectsWithIds);
              break;
          case /* SerialSideEffects */2 :
              logYellow("Next state =");
              logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, stateMachine.state.contents) + " (same state)"));
              var sideEffectsWithIds$1 = List.mapi((function (i, sideEffect) {
                      return [
                              sideEffect,
                              stateMachine.nextSideEffectId.contents + i | 0
                            ];
                    }), update._0);
              logSideEffectsWithIds(undefined, "Serial", stringifySideEffect, sideEffectsWithIds$1);
              break;
          case /* UpdateWithSideEffects */3 :
              var nextState$1 = update._0;
              logYellow("Next state = ");
              var tmp$1;
              try {
                tmp$1 = Caml_obj.caml_equal(nextState$1, stateMachine.state.contents) ? " (same state)" : "";
              }
              catch (raw_msg$1){
                var msg$1 = Caml_js_exceptions.internalToOCamlException(raw_msg$1);
                if (msg$1.RE_EXN_ID === "Invalid_argument") {
                  if (msg$1._1 === "equal: functional value") {
                    tmp$1 = "(unknown state equality)";
                  } else {
                    throw msg$1;
                  }
                } else {
                  throw msg$1;
                }
              }
              logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, nextState$1) + tmp$1));
              var sideEffectsWithIds$2 = List.mapi((function (i, sideEffect) {
                      return [
                              sideEffect,
                              stateMachine.nextSideEffectId.contents + i | 0
                            ];
                    }), update._1);
              logSideEffectsWithIds(undefined, "Parallel", stringifySideEffect, sideEffectsWithIds$2);
              break;
          case /* UpdateWithSerialSideEffects */4 :
              var nextState$2 = update._0;
              logYellow("Next state = ");
              var tmp$2;
              try {
                tmp$2 = Caml_obj.caml_equal(nextState$2, stateMachine.state.contents) ? " (same state)" : "";
              }
              catch (raw_msg$2){
                var msg$2 = Caml_js_exceptions.internalToOCamlException(raw_msg$2);
                if (msg$2.RE_EXN_ID === "Invalid_argument") {
                  if (msg$2._1 === "equal: functional value") {
                    tmp$2 = "(unknown state equality)";
                  } else {
                    throw msg$2;
                  }
                } else {
                  throw msg$2;
                }
              }
              logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, nextState$2) + tmp$2));
              var sideEffectsWithIds$3 = List.mapi((function (i, sideEffect) {
                      return [
                              sideEffect,
                              stateMachine.nextSideEffectId.contents + i | 0
                            ];
                    }), update._1);
              logSideEffectsWithIds(undefined, "Serial", stringifySideEffect, sideEffectsWithIds$3);
              break;
          
        }
      }
      return logYellow("\n");
    }
    var transition = {
      eventId: eventId,
      event: $$event,
      eventSource: eventSource,
      update: update,
      sideEffectIds: sideEffectIds
    };
    var json = transition_encode(match._0, match._1, match._3, match._2, transition);
    fetch(process.env.HOSTNAME + "/api/log_transition", Fetch.RequestInit.make(/* Post */2, {
                "Content-Type": "application/json"
              }, Caml_option.some(JSON.stringify(json)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
    return ;
  }
  
}

function dispatch(eventSource, _event, stateMachine) {
  while(true) {
    var $$event = _event;
    var eventId = stateMachine.nextEventId.contents;
    stateMachine.nextEventId.contents = stateMachine.nextEventId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextEventId.contents + 1 | 0;
    maybeLogTransition($$event, eventSource, stateMachine);
    var update;
    try {
      update = Curry._3(stateMachine.reducer, stateMachine.state.contents, $$event, eventId);
    }
    catch (raw_jsExn){
      var jsExn = Caml_js_exceptions.internalToOCamlException(raw_jsExn);
      if (jsExn.RE_EXN_ID === Js_exn.$$Error) {
        var failure_failWith = {
          TAG: /* FailWithJsExn */1,
          _0: jsExn._1
        };
        var failure_context = {
          TAG: /* DidErrDuringTransition */0,
          _0: {
            state: stateMachine.state.contents,
            event: $$event,
            eventId: eventId,
            extraMessage: ""
          }
        };
        var failure = {
          failWith: failure_failWith,
          context: failure_context
        };
        var failEvent = Curry._1(stateMachine.failEventFromFailure, failure);
        _event = failEvent;
        continue ;
      }
      throw jsExn;
    }
    if (update === /* Ignore */0) {
      var match = stateMachine.options.logTransitions;
      if (typeof match !== "number" && match.TAG === /* DoLogTransitions */0) {
        if (Curry._2(match._4, stateMachine.state.contents, $$event)) {
          
        } else {
          Curry._1(Log$SmartcutsMacros.stateMachineCore.log1, "IGNORING!!");
        }
      }
      
    }
    var tmp;
    if (typeof update === "number") {
      tmp = Promise.resolve(undefined);
    } else {
      switch (update.TAG | 0) {
        case /* Update */0 :
            stateMachine.state.contents = update._0;
            stateMachine.history.contents = recordTransition(eventId, $$event, eventSource, update, /* [] */0, stateMachine.history.contents);
            maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, /* [] */0);
            tmp = Promise.resolve(undefined);
            break;
        case /* SideEffects */1 :
            var sideEffectsWithIds = List.map((function (sideEffect) {
                    var sideEffectId = stateMachine.nextSideEffectId.contents;
                    stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                    return [
                            sideEffect,
                            sideEffectId
                          ];
                  }), update._0);
            stateMachine.history.contents = recordTransition(eventId, $$event, eventSource, update, List.map((function (prim) {
                        return prim[1];
                      }), sideEffectsWithIds), stateMachine.history.contents);
            maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, Belt_List.map(sideEffectsWithIds, (function (prim) {
                        return prim[1];
                      })));
            tmp = Promise.all($$Array.of_list(List.map((function (param) {
                              return Curry._3(stateMachine.execSideEffect, param[1], stateMachine, param[0]);
                            }), sideEffectsWithIds))).then(function (param) {
                  return Promise.resolve(undefined);
                });
            break;
        case /* SerialSideEffects */2 :
            var sideEffectsWithIds$1 = List.map((function (sideEffect) {
                    var sideEffectId = stateMachine.nextSideEffectId.contents;
                    stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                    return [
                            sideEffect,
                            sideEffectId
                          ];
                  }), update._0);
            stateMachine.history.contents = recordTransition(eventId, $$event, eventSource, update, List.map((function (prim) {
                        return prim[1];
                      }), sideEffectsWithIds$1), stateMachine.history.contents);
            maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, Belt_List.map(sideEffectsWithIds$1, (function (prim) {
                        return prim[1];
                      })));
            tmp = List.fold_left((function (promise, param) {
                    var sideEffectId = param[1];
                    var sideEffect = param[0];
                    return promise.then(function (param) {
                                return Curry._3(stateMachine.execSideEffect, sideEffectId, stateMachine, sideEffect);
                              });
                  }), Promise.resolve(undefined), sideEffectsWithIds$1);
            break;
        case /* UpdateWithSideEffects */3 :
            var sideEffects = update._1;
            var match$1 = stateMachine.options.logTransitions;
            if (typeof match$1 !== "number" && !Curry._2(match$1._4, stateMachine.state.contents, $$event) && typeof match$1 !== "number" && match$1.TAG === /* DoLogTransitions */0) {
              Curry._2(Log$SmartcutsMacros.stateMachineCore.log2, "Side effect count", List.length(sideEffects));
            }
            var sideEffectsWithIds$2 = List.map((function (sideEffect) {
                    var sideEffectId = stateMachine.nextSideEffectId.contents;
                    stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                    return [
                            sideEffect,
                            sideEffectId
                          ];
                  }), sideEffects);
            stateMachine.state.contents = update._0;
            stateMachine.history.contents = recordTransition(eventId, $$event, eventSource, update, List.map((function (prim) {
                        return prim[1];
                      }), sideEffectsWithIds$2), stateMachine.history.contents);
            maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, Belt_List.map(sideEffectsWithIds$2, (function (prim) {
                        return prim[1];
                      })));
            tmp = Promise.all($$Array.of_list(List.map((function (param) {
                                return Curry._3(stateMachine.execSideEffect, param[1], stateMachine, param[0]);
                              }), sideEffectsWithIds$2))).then(function (param) {
                    return Promise.resolve(undefined);
                  }).catch(function (err) {
                  console.error(err);
                  return Util$SmartcutsMacros.logAndRaiseJsError("Uncaught exception during UpdateWithSideEffects");
                });
            break;
        case /* UpdateWithSerialSideEffects */4 :
            var sideEffectsWithIds$3 = List.map((function (sideEffect) {
                    var sideEffectId = stateMachine.nextSideEffectId.contents;
                    stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                    return [
                            sideEffect,
                            sideEffectId
                          ];
                  }), update._1);
            stateMachine.state.contents = update._0;
            stateMachine.history.contents = recordTransition(eventId, $$event, eventSource, update, List.map((function (prim) {
                        return prim[1];
                      }), sideEffectsWithIds$3), stateMachine.history.contents);
            maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, Belt_List.map(sideEffectsWithIds$3, (function (prim) {
                        return prim[1];
                      })));
            tmp = List.fold_left((function (promise, param) {
                    var sideEffectId = param[1];
                    var sideEffect = param[0];
                    return promise.then(function (param) {
                                return Curry._3(stateMachine.execSideEffect, sideEffectId, stateMachine, sideEffect);
                              });
                  }), Promise.resolve(undefined), sideEffectsWithIds$3);
            break;
        
      }
    }
    return tmp.catch((function($$event,eventId){
              return function (error) {
                var failure_failWith = {
                  TAG: /* FailWithJsPromiseError */2,
                  _0: error
                };
                var failure_context = {
                  TAG: /* DidErrDuringTransition */0,
                  _0: {
                    state: stateMachine.state.contents,
                    event: $$event,
                    eventId: eventId,
                    extraMessage: ""
                  }
                };
                var failure = {
                  failWith: failure_failWith,
                  context: failure_context
                };
                var failEvent = Curry._1(stateMachine.failEventFromFailure, failure);
                return dispatch(eventSource, failEvent, stateMachine);
              }
              }($$event,eventId)));
  };
}

function wrapExecSideEffectToHandleJsPromiseError(failEventFromFailure, execSideEffect, sideEffectId, stateMachine, sideEffect) {
  var promise;
  try {
    promise = Curry._3(execSideEffect, sideEffectId, stateMachine, sideEffect);
  }
  catch (raw_jsExn){
    var jsExn = Caml_js_exceptions.internalToOCamlException(raw_jsExn);
    if (jsExn.RE_EXN_ID === Js_exn.$$Error) {
      return dispatch({
                  TAG: /* ViaSideEffect */1,
                  _0: sideEffect,
                  _1: sideEffectId
                }, Curry._1(failEventFromFailure, {
                      failWith: {
                        TAG: /* FailWithJsExn */1,
                        _0: jsExn._1
                      },
                      context: {
                        TAG: /* DidErrDuringSideEffect */1,
                        _0: {
                          sideEffectId: sideEffectId,
                          sideEffect: sideEffect,
                          maybeState: Caml_option.some(stateMachine.state.contents),
                          extraMessage: ""
                        }
                      }
                    }), stateMachine);
    }
    throw jsExn;
  }
  return promise.catch(function (error) {
              return dispatch({
                          TAG: /* ViaSideEffect */1,
                          _0: sideEffect,
                          _1: sideEffectId
                        }, Curry._1(failEventFromFailure, {
                              failWith: {
                                TAG: /* FailWithJsPromiseError */2,
                                _0: error
                              },
                              context: {
                                TAG: /* DidErrDuringSideEffect */1,
                                _0: {
                                  sideEffectId: sideEffectId,
                                  sideEffect: sideEffect,
                                  maybeState: Caml_option.some(stateMachine.state.contents),
                                  extraMessage: ""
                                }
                              }
                            }), stateMachine);
            });
}

function wrapChildExecSideEffectToHandleJsPromiseError(failEventFromFailure, buildFailureWithJsPromiseError, buildFailureWithJsExnError, execSideEffect, maybeStateFromRootState, dispatch, sideEffectId, stateMachine, sideEffect) {
  var promise;
  try {
    promise = Curry._5(execSideEffect, maybeStateFromRootState, dispatch, sideEffectId, stateMachine, sideEffect);
  }
  catch (raw_jsExnError){
    var jsExnError = Caml_js_exceptions.internalToOCamlException(raw_jsExnError);
    if (jsExnError.RE_EXN_ID === Js_exn.$$Error) {
      return Curry._3(dispatch, {
                  TAG: /* ViaSideEffect */1,
                  _0: sideEffect,
                  _1: sideEffectId
                }, Curry._1(failEventFromFailure, Curry._2(buildFailureWithJsExnError, jsExnError._1, {
                          sideEffectId: sideEffectId,
                          sideEffect: sideEffect,
                          maybeState: Curry._1(maybeStateFromRootState, stateMachine.state.contents),
                          extraMessage: ""
                        })), stateMachine);
    }
    throw jsExnError;
  }
  return promise.catch(function (jsPromiseError) {
              return Curry._3(dispatch, {
                          TAG: /* ViaSideEffect */1,
                          _0: sideEffect,
                          _1: sideEffectId
                        }, Curry._1(failEventFromFailure, Curry._2(buildFailureWithJsPromiseError, jsPromiseError, {
                                  sideEffectId: sideEffectId,
                                  sideEffect: sideEffect,
                                  maybeState: Curry._1(maybeStateFromRootState, stateMachine.state.contents),
                                  extraMessage: ""
                                })), stateMachine);
            });
}

function wrapReducerToHandleJsExn(buildFailureContext, failEventFromFailure, buildSideEffectDispatch, reducer, state, $$event, eventId) {
  try {
    return Curry._3(reducer, state, $$event, eventId);
  }
  catch (raw_jsExn){
    var jsExn = Caml_js_exceptions.internalToOCamlException(raw_jsExn);
    if (jsExn.RE_EXN_ID === Js_exn.$$Error) {
      var failure_failWith = {
        TAG: /* FailWithJsExn */1,
        _0: jsExn._1
      };
      var failure_context = Curry._1(buildFailureContext, {
            state: state,
            event: $$event,
            eventId: eventId,
            extraMessage: ""
          });
      var failure = {
        failWith: failure_failWith,
        context: failure_context
      };
      var failEvent = Curry._1(failEventFromFailure, failure);
      return {
              TAG: /* SideEffects */1,
              _0: {
                hd: Curry._1(buildSideEffectDispatch, failEvent),
                tl: /* [] */0
              }
            };
    }
    throw jsExn;
  }
}

function wrapCallback0ToHandleJsExn(failEventFromFailure, dispatch, buildListener, exceptionToOtherFailureReason, rootStateMachine, defaultReturn, listenerFn, param) {
  try {
    return Curry._1(listenerFn, undefined);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    var listener = Curry._1(buildListener, undefined);
    var failure_failWith = exn.RE_EXN_ID === Js_exn.$$Error ? ({
          TAG: /* FailWithJsExn */1,
          _0: exn._1
        }) : ({
          TAG: /* FailWithOtherReason */0,
          _0: Curry._1(exceptionToOtherFailureReason, exn)
        });
    var failure_context = {
      TAG: /* DidErrDuringListener */2,
      _0: {
        listener: listener,
        extraMessage: ""
      }
    };
    var failure = {
      failWith: failure_failWith,
      context: failure_context
    };
    var failEvent = Curry._1(failEventFromFailure, failure);
    Curry._3(dispatch, {
          TAG: /* ViaListener */0,
          _0: listener
        }, failEvent, rootStateMachine);
    if (defaultReturn !== undefined) {
      return Caml_option.valFromOption(defaultReturn);
    }
    throw exn;
  }
}

function wrapCallback1ToHandleJsExn(failEventFromFailure, dispatch, buildListener, exceptionToOtherFailureReason, rootStateMachine, defaultReturn, listenerFn, arg) {
  try {
    return Curry._1(listenerFn, arg);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    var listener = Curry._1(buildListener, arg);
    var failure_failWith = exn.RE_EXN_ID === Js_exn.$$Error ? ({
          TAG: /* FailWithJsExn */1,
          _0: exn._1
        }) : ({
          TAG: /* FailWithOtherReason */0,
          _0: Curry._1(exceptionToOtherFailureReason, exn)
        });
    var failure_context = {
      TAG: /* DidErrDuringListener */2,
      _0: {
        listener: listener,
        extraMessage: ""
      }
    };
    var failure = {
      failWith: failure_failWith,
      context: failure_context
    };
    var failEvent = Curry._1(failEventFromFailure, failure);
    Curry._3(dispatch, {
          TAG: /* ViaListener */0,
          _0: listener
        }, failEvent, rootStateMachine);
    if (defaultReturn !== undefined) {
      return Caml_option.valFromOption(defaultReturn);
    }
    throw exn;
  }
}

function wrapCallback2ToHandleJsExn(failEventFromFailure, dispatch, buildListener, exceptionToOtherFailureReason, rootStateMachine, defaultReturn, listenerFn, arg1, arg2) {
  try {
    return Curry._2(listenerFn, arg1, arg2);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    var listener = Curry._2(buildListener, arg1, arg2);
    var failure_failWith = exn.RE_EXN_ID === Js_exn.$$Error ? ({
          TAG: /* FailWithJsExn */1,
          _0: exn._1
        }) : ({
          TAG: /* FailWithOtherReason */0,
          _0: Curry._1(exceptionToOtherFailureReason, exn)
        });
    var failure_context = {
      TAG: /* DidErrDuringListener */2,
      _0: {
        listener: listener,
        extraMessage: ""
      }
    };
    var failure = {
      failWith: failure_failWith,
      context: failure_context
    };
    var failEvent = Curry._1(failEventFromFailure, failure);
    Curry._3(dispatch, {
          TAG: /* ViaListener */0,
          _0: listener
        }, failEvent, rootStateMachine);
    if (defaultReturn !== undefined) {
      return Caml_option.valFromOption(defaultReturn);
    }
    throw exn;
  }
}

function make$1(maxHistory, logTransitionsOpt, initialState, failEventFromFailure, buildSideEffectDispatch, reducer, execSideEffect, param) {
  var logTransitions = logTransitionsOpt !== undefined ? logTransitionsOpt : /* DontLogTransitions */0;
  return {
          state: {
            contents: initialState
          },
          history: {
            contents: {
              firstState: initialState,
              transitions: [],
              maxLength: maxHistory
            }
          },
          nextEventId: {
            contents: 1
          },
          nextSideEffectId: {
            contents: 1
          },
          lastFailureTimestampsByKey: undefined,
          reducer: (function (param, param$1, param$2) {
              return wrapReducerToHandleJsExn((function (transitionErrorContext) {
                            return {
                                    TAG: /* DidErrDuringTransition */0,
                                    _0: transitionErrorContext
                                  };
                          }), failEventFromFailure, buildSideEffectDispatch, reducer, param, param$1, param$2);
            }),
          execSideEffect: (function (param, param$1, param$2) {
              return wrapExecSideEffectToHandleJsPromiseError(failEventFromFailure, execSideEffect, param, param$1, param$2);
            }),
          failEventFromFailure: failEventFromFailure,
          options: {
            logTransitions: logTransitions
          }
        };
}

function createDispatchChildEvent(dispatch, wrapChildEvent, wrapChildSideEffect, wrapChildListener) {
  return function (eventSource, $$event, rootStateMachine) {
    var tmp;
    tmp = typeof eventSource === "number" ? /* ViaInitialize */0 : (
        eventSource.TAG === /* ViaListener */0 ? ({
              TAG: /* ViaListener */0,
              _0: Curry._1(wrapChildListener, eventSource._0)
            }) : ({
              TAG: /* ViaSideEffect */1,
              _0: Curry._1(wrapChildSideEffect, eventSource._0),
              _1: eventSource._1
            })
      );
    return Curry._3(dispatch, tmp, Curry._1(wrapChildEvent, $$event), rootStateMachine);
  };
}

function hoistChildReducer(stateWrapper, sideEffectWrapper, childFailEventFromChildFailure, buildChildFailureContext, createChildSideEffectDispatchEventFromChildEvent, childReducer) {
  var childReducerWithExnHandling = function (param, param$1, param$2) {
    return wrapReducerToHandleJsExn(buildChildFailureContext, childFailEventFromChildFailure, Curry.__1(createChildSideEffectDispatchEventFromChildEvent), childReducer, param, param$1, param$2);
  };
  return function (childState, childEvent, eventId) {
    var newRecordingState = childReducerWithExnHandling(childState, childEvent, eventId);
    if (typeof newRecordingState === "number") {
      return /* Ignore */0;
    }
    switch (newRecordingState.TAG | 0) {
      case /* Update */0 :
          return {
                  TAG: /* Update */0,
                  _0: Curry._1(stateWrapper, newRecordingState._0)
                };
      case /* SideEffects */1 :
          return {
                  TAG: /* SideEffects */1,
                  _0: List.map(Curry.__1(sideEffectWrapper), newRecordingState._0)
                };
      case /* SerialSideEffects */2 :
          return {
                  TAG: /* SideEffects */1,
                  _0: List.map(sideEffectWrapper, newRecordingState._0)
                };
      case /* UpdateWithSideEffects */3 :
          return {
                  TAG: /* UpdateWithSideEffects */3,
                  _0: Curry._1(stateWrapper, newRecordingState._0),
                  _1: List.map(sideEffectWrapper, newRecordingState._1)
                };
      case /* UpdateWithSerialSideEffects */4 :
          return {
                  TAG: /* UpdateWithSerialSideEffects */4,
                  _0: Curry._1(stateWrapper, newRecordingState._0),
                  _1: List.map(sideEffectWrapper, newRecordingState._1)
                };
      
    }
  };
}

function extractStateFromUpdate(update) {
  if (typeof update === "number") {
    return ;
  }
  switch (update.TAG | 0) {
    case /* Update */0 :
    case /* UpdateWithSideEffects */3 :
    case /* UpdateWithSerialSideEffects */4 :
        return Caml_option.some(update._0);
    default:
      return ;
  }
}

function recordFailureOccurrence(key, stateMachine) {
  var nextLastFailureTimestampsByKey = Belt_MapString.update(stateMachine.lastFailureTimestampsByKey, key, (function (maybeVal) {
          var arrToAppendTo = maybeVal !== undefined ? (
              maybeVal.length === 4 ? Belt_Array.slice(maybeVal, 1, 3) : maybeVal
            ) : [];
          return $$Array.append(arrToAppendTo, [Date.now()]);
        }));
  return {
          state: stateMachine.state,
          history: stateMachine.history,
          nextEventId: stateMachine.nextEventId,
          nextSideEffectId: stateMachine.nextSideEffectId,
          lastFailureTimestampsByKey: nextLastFailureTimestampsByKey,
          reducer: stateMachine.reducer,
          execSideEffect: stateMachine.execSideEffect,
          failEventFromFailure: stateMachine.failEventFromFailure,
          options: stateMachine.options
        };
}

function isLikelyInfiniteFailureLoop(key, param) {
  var now = Date.now();
  var lastFailureTimestamps = Belt_MapString.get(param.lastFailureTimestampsByKey, key);
  if (lastFailureTimestamps !== undefined) {
    return Belt_Array.keep(lastFailureTimestamps, (function (ts) {
                  return now - ts < 1000.0;
                })).length === 4;
  } else {
    return false;
  }
}

var maxFailureTimestamps = 4;

exports.update_encode = update_encode;
exports.update_decode = update_decode;
exports.stringifyUpdate = stringifyUpdate;
exports.eventSource_encode = eventSource_encode;
exports.eventSource_decode = eventSource_decode;
exports.mapEventSource = mapEventSource;
exports.stringifyEventSource = stringifyEventSource;
exports.$$History = $$History;
exports.Failure = Failure;
exports.Exit = Exit;
exports.logYellow = logYellow;
exports.logSideEffects = logSideEffects;
exports.logSideEffectsWithIds = logSideEffectsWithIds;
exports.maybeLogTransition = maybeLogTransition;
exports.maybeLogUpdate = maybeLogUpdate;
exports.dispatch = dispatch;
exports.wrapExecSideEffectToHandleJsPromiseError = wrapExecSideEffectToHandleJsPromiseError;
exports.wrapChildExecSideEffectToHandleJsPromiseError = wrapChildExecSideEffectToHandleJsPromiseError;
exports.wrapReducerToHandleJsExn = wrapReducerToHandleJsExn;
exports.wrapCallback0ToHandleJsExn = wrapCallback0ToHandleJsExn;
exports.wrapCallback1ToHandleJsExn = wrapCallback1ToHandleJsExn;
exports.wrapCallback2ToHandleJsExn = wrapCallback2ToHandleJsExn;
exports.make = make$1;
exports.createDispatchChildEvent = createDispatchChildEvent;
exports.hoistChildReducer = hoistChildReducer;
exports.extractStateFromUpdate = extractStateFromUpdate;
exports.maxFailureTimestamps = maxFailureTimestamps;
exports.recordFailureOccurrence = recordFailureOccurrence;
exports.isLikelyInfiniteFailureLoop = isLikelyInfiniteFailureLoop;
/* logYellow Not a pure module */
